import Components from './../Component';

export default class Accessibility extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    //this.form = element;
    //this.form.addEventListener("submit", this.onSubmit.bind(this));


    if (this.getCookie('accessibility') != 1){
      //this.$('#accessibility-default').attr('checked','checked');
      this.$('body').removeClass('accessibility-adapted');
    }else{
      //this.$('#accessibility-adapted').attr('checked','checked');
      this.$('body').addClass('accessibility-adapted');
    }

    this.$('.btn-accessibility').on('click', function (){
        if (this.getCookie('accessibility') != 1){
          this.saveCookiePreferences(1);
          this.$('body').addClass('accessibility-adapted');
        }else{
          this.saveCookiePreferences(0);
          this.$('body').removeClass('accessibility-adapted');
        }
    }.bind(this));
  }

  /*
  closeModal(){
    this.$('#block-accessibility').removeClass('open');
    this.$('body').removeClass('modal-open');
    this.$('.overlay').removeClass('show');
    this.$('[data-modal-launcher=' + this.$('#block-accessibility').attr('id') + ']').focus();
  }

  onSubmit(e){
    this.closeModal();
    e.preventDefault();

   if (this.$('input[type]:checked').val() == 'adapted'){
      this.$('body').addClass('accessibility-adapted');
      this.saveCookiePreferences(1);
   }else{
      this.$('body').removeClass('accessibility-adapted');
     this.saveCookiePreferences(0);
   }
  }*/

  getCookie (name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  saveCookiePreferences(value){
    document.cookie = `accessibility=${value}; path=/; max-age=${60 * 60 * 24 * 100};`;
  }

}
